export const REDUX_SET = '/redux/container/CustomerEditContainer/set';
export const REDUX_RESET = '/redux/container/CustomerEditContainer/reset';
